import * as tslib_1 from "tslib";
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectCurrentTrip } from '../trip/trip.selectors';
export var selectPaxEditState = createFeatureSelector('paxEdit');
export var selectCurrentPassenger = createSelector(selectPaxEditState, selectCurrentTrip, function (paxEditState) {
    return paxEditState.paxSelectedForEdit;
});
export var selectPassengerEditInfo = createSelector(selectPaxEditState, selectCurrentPassenger, function (paxEditState, currentPassenger) {
    if (!currentPassenger) {
        return null;
    }
    return {
        passenger: currentPassenger,
        ktn: paxEditState.paxEditKTN || currentPassenger.knownTravelerNumber,
        redress: paxEditState.paxEditRedress || currentPassenger.redressNumber,
        hawaiianMiles: paxEditState.paxEditHawaiianMiles || currentPassenger.hawaiianMilesNumber,
    };
});
//# sourceMappingURL=pax-edit.selectors.js.map